import { CampaignType } from '@mm/state/model/CampaignsModel';
import WidgetModel, { WidgetTypes } from '@mm/state/model/WidgetModel';

export const filterCampaignWidgets = (
  campaign: CampaignType,
  widgets: WidgetModel[],
) => {
  const smsOnly = campaign?.platforms?.join('') === 'sms';
  const facebook = campaign?.platforms?.includes('facebook');

  let widgetsToExclude: WidgetTypes[] = [];

  if (!facebook) {
    widgetsToExclude = [...widgetsToExclude, WidgetTypes.OTN];
  }

  if (smsOnly) {
    widgetsToExclude = [
      ...widgetsToExclude,
      WidgetTypes.GALLERY,
      WidgetTypes.ATTACHMENT,
      WidgetTypes.TYPING,
      WidgetTypes.AUDIO,
    ];
  }

  const filteredWidgets = widgets.filter(
    widget => !widgetsToExclude.includes(widget.type),
  );

  return {
    filteredWidgets,
    widgetsToExclude,
    smsOnly,
  };
};
